import API from 'src/api'
import { http } from '../boot/axios'

export default {
  URL: API.GRAPHQL_URL + 'dashboards',
  SUPER_URL: API.GRAPHQL_URL + 'reports/dashboard',
  getDashboards () {
    return new Promise((resolve, reject) => {
      http.get(`${this.URL}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  newDashboard (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.URL}`, payload)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  deleteDashboard (id) {
    return new Promise((resolve, reject) => {
      http.delete(`${this.URL}/${id}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  duplicateDashboard (payload) {
    return new Promise((resolve, reject) => {
      http.post(`${this.URL}/${payload.id}/duplicate`, payload)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  updateDashboard (payload) {
    return new Promise((resolve, reject) => {
      http.put(`${this.URL}/${payload.id}`, payload)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  favoriteDashboard (id) {
    return new Promise((resolve, reject) => {
      http.post(`${this.URL}/${id}/favorite`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  fetchWidgets (id) {
    return new Promise((resolve, reject) => {
      http.get(`${this.URL}/${id}/widgets`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  getSuperAdminForms () {
    return new Promise((resolve, reject) => {
      http.get(`${this.SUPER_URL}/forms-module/`)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  getSuperAdminActionPlans () {
    return new Promise((resolve, reject) => {
      http.get(`${this.SUPER_URL}/action-plans-module/`)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  getSuperAdminUsers () {
    return new Promise((resolve, reject) => {
      http.get(`${this.SUPER_URL}/users-module/`)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  },
  getSuperAdminAgenda () {
    return new Promise((resolve, reject) => {
      http.get(`${this.SUPER_URL}/agenda-module/`)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
    })
  }
}
